export enum FeatureFlagEnum {
  NEW_SIGNUP_FLOW = 'NEW_SIGNUP_FLOW',
  BTL_APPLICATION = 'BTL_APPLICATION',
}
